<template>
  <FicheCollab />
</template>

<script>
// Components
import FicheCollab from "@/components/FicheCollab.vue";
export default {
  name: "FicheCollabSimuView",

  components: {
    FicheCollab,
  },
};
</script>

<style scoped>
</style>